<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
          autocomplete="off"
        >
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="lg:mb-4">
            </div>
            <div class="lg:mb-2" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <div class="w-full">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="true"
                    id-prefix="group"
                  >
                    <template slot="label">{{$t('app.client')}}</template>
                  </AccessibleElSelect>
                </div>
                <base-button class="ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.name')}}
                  <el-form-item prop="name">
                    <el-input
                      disabled
                      class="w-full"
                      v-model="form.name"
                      maxlength='50'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
            <div class="flex items-center mb-1">
              <label class="text-sm font-semibold text-secondary-600 block">{{$t('configurations.group_type')}}</label>
              <base-tooltip-icon :formatContent="true" size="sm" :content="tooltipTipoGrupo" class="ml-2"/>
            </div>
              <AccessibleElSelect
                v-model="form.tipo"
                prop="tipo"
                :options="tiposGrupoForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="true"
                id-prefix="group"
              />
            </div>
            <!-- <div class="lg:mb-2" v-if="form.tipo == 2 || form.tipo === 3">
              <div class="mandatory">
                <div class="flex flex-row items-center  mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block">{{$t('configurations.emails')}}</label>
                  <base-tooltip-icon size="sm" :content="contentTooltipEmail" class="ml-2"/>
                </div>
                <el-form-item prop="email">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.email"
                    maxlength='255'
                  />
                </el-form-item>
              </div>
            </div> -->

            <div class="mb-6">
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.desc')}}
                <el-form-item prop="Descripcion">
                  <el-input
                    type="textarea"
                    :rows="3"
                    class="w-full"
                    :aria-label="$t('groups.desc')"
                    v-model="form.Descripcion"
                    disabled
                  />
                </el-form-item>
              </label>
            </div>

            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="ver-todo-groups-switch" class="sr-only">
                    {{$t('configurations.ver_todo_groups')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="ver-todo-groups-switch"
                    :aria-label="$t('configurations.ver_todo_groups')"
                    class="switch-text break-normal" 
                    disabled 
                    v-model="form.verTodoGroups" 
                    :active-text="$t('configurations.ver_todo_groups')"/>
                  <base-tooltip-icon size="sm" :content="tooltipverTodoGroups" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="ver-todo-statuses-switch" class="sr-only">
                    {{$t('configurations.ver_todo_statuses')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="ver-todo-statuses-switch"
                    :aria-label="$t('configurations.ver_todo_statuses')"
                    class="switch-text break-normal" 
                    disabled 
                    v-model="form.verTodoStatuses" 
                    :active-text="$t('configurations.ver_todo_statuses')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="ver-todo-companies-switch" class="sr-only">
                    {{$t('configurations.ver_todo_companies')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="ver-todo-companies-switch"
                    :aria-label="$t('configurations.ver_todo_companies')"
                    class="switch-text break-normal" 
                    disabled 
                    v-model="form.verTodoCompanies" 
                    :active-text="$t('configurations.ver_todo_companies')"/>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>

            <div class="mb-6" v-if="hasModulePermisosGruposTraspasoNEOs">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="ver-todo-asignar-grupos-switch" class="sr-only">
                    {{$t('configurations.ver_todo_groups_asign')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="ver-todo-asignar-grupos-switch"
                    :aria-label="$t('configurations.ver_todo_groups_asign')"
                    class="switch-text break-normal" 
                    disabled
                    v-model="form.verTodoAsignarGrupos" 
                    :active-text="$t('configurations.ver_todo_groups_asign')"/>
                </div>
              </div>
            </div>

          <base-collapsible-form 
            ref="baseCollapsibleAlerts" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.group_alert')}}</h2>
            </template>
            <template slot="content">

              <div class="mt-2 mb-4" >
                  <div >
                    <label for="enviar-avisos-switch" class="sr-only">
                      {{$t('companies.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                    </label>
                    <el-switch 
                      id="enviar-avisos-switch"
                      :aria-label="$t('companies.active')"
                      class="switch-text break-normal" 
                      disabled 
                      v-model="form.EnviarAvisos" 
                      :active-text="$t('companies.active')"/>
                  </div>
              </div>
              
              <div class="mb-4" v-if="form.tipo === 1 || form.tipo === 2">
                  <div >
                    <label for="enviar-avisos-usuarios-switch" class="sr-only">
                      {{$t('configurations.send_alerts_users')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                    </label>
                    <el-switch 
                      id="enviar-avisos-usuarios-switch"
                      :aria-label="$t('configurations.send_alerts_users')"
                      class="switch-text break-normal" 
                      disabled 
                      v-model="form.EnviarAvisosUsuarios" 
                      :active-text="$t('configurations.send_alerts_users')"/>
                  </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-nueva-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_alerts')}}</span>
                    <el-switch
                      id="switch-email-aviso-nueva"
                      :aria-label="$t('configurations.email_alerts_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoNueva"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoNueva">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-nueva-label"
                      v-model="form.EmailAvisoNueva"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-descargada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_downloads')}}</span>
                    <el-switch
                      v-if="form.tipo === 1 || form.tipo === 2"
                      id="switch-email-aviso-descargada"
                      :aria-label="$t('configurations.email_downloads_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoDescargada"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoDescargada">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-descargada-label"
                      v-model="form.EmailAvisoDescargada"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>
              
              <div class="lg:mb-2" v-if="hasPermModuleSMS && (form.tipo == 1 || form.tipo === 2)">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.sms_downloads')}}
                    <el-form-item prop="SMSAvisoDescargada">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        maxlength="9"
                        v-model="form.SMSAvisoDescargada"
                      >
                        <template slot="prepend">{{formatCodigoPaisSMSAvisoDescargada}}</template>
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-tramitada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tramitada')}}</span>
                    <el-switch
                      id="switch-email-aviso-tramitada"
                      :aria-label="$t('configurations.email_tramitada_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoTramitada"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoTramitada">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-tramitada-label"
                      v-model="form.EmailAvisoTramitada"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-0" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.download_alert_days_form')}}
                      <el-form-item prop="DiasAviso" class="mb-0">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model="form.DiasAviso"
                          maxlength='5'
                          :placeholder="$t('configurations.default_disabled')"
                        />
                      </el-form-item>
                    </label>
                  </div>
                  <div class="px-2 w-full lg:mb-0">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.end_alert_days_label_form')}}
                      <el-form-item prop="DiasAvisoFinTramite" class="mb-0">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model="form.DiasAvisoFinTramite"
                          maxlength='5'
                          :placeholder="$t('configurations.default_disabled')"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mt-5 mb-5 mr-20">
                  <label for="agrupar-emails-avisos-switch" class="sr-only">
                    {{$t('configurations.mails_group_status')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="agrupar-emails-avisos-switch"
                    :aria-label="$t('configurations.mails_group_status')"
                    class="switch-text break-normal" 
                    disabled 
                    v-model="form.AgruparEmailsAvisos" 
                    :active-text="$t('configurations.mails_group_status')"/>
                  </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span v-if="form.AgruparEmailsAvisos" id="group-email-ultima-llamada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.mails_group_status_input')}}</span>
                    <span v-else id="group-email-ultima-llamada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_ultima_llamada')}}</span>
                    <el-switch
                      id="switch-email-ultima-llamada"
                      :aria-label="$t(form.AgruparEmailsAvisos ? 'configurations.email_ultima_llamada_grouped_users_single_aria' : 'configurations.email_ultima_llamada_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoDiasAviso"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoUltimaLlamada">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-ultima-llamada-label"
                      v-model="form.EmailAvisoUltimaLlamada"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="lg:mb-2" v-if="form.AgruparEmailsAvisos === false && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-tramitacion-urgente-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tramitacion_urgente')}}</span>
                    <el-switch
                      id="switch-email-tramitacion-urgente"
                      :aria-label="$t('configurations.email_tramitacion_urgente_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoTramitacionUrgente">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-tramitacion-urgente-label"
                      v-model="form.EmailAvisoTramitacionUrgente"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>
              <div class="lg:mb-2" v-if="form.AgruparEmailsAvisos === false && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-errores-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_neos_error')}}</span>
                    <el-switch
                      id="switch-email-aviso-errores"
                      :aria-label="$t('configurations.email_neos_error_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoErrores"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoErrores">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-errores-label"
                      v-model="form.EmailAvisoErrores"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-vinculaciones-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_vincul')}}</span>
                    <el-switch
                      id="switch-email-aviso-vinculaciones"
                      :aria-label="$t('configurations.email_aviso_vincul_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoVinculaciones"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoVinculaciones">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-vinculaciones-label"
                      v-model="form.EmailAvisoVinculaciones"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="hasModuleFlujoEstadosAvisos && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-principal-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_princ')}}</span>
                    <el-switch
                      id="switch-email-aviso-principal"
                      :aria-label="$t('configurations.email_aviso_princ_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoPrincipal"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoPrincipal">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-principal-label"
                      v-model="form.EmailAvisoPrincipal"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="hasModuleFlujoEstadosAvisos && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-secundario-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_sec')}}</span>
                    <el-switch
                      id="switch-email-aviso-secundario"
                      :aria-label="$t('configurations.email_aviso_sec_users_single_aria')"
                      class="switch-text break-normal"
                      disabled
                      v-model="form.EnviarAvisoUsuariosEmailAvisoSecundario"
                      :active-text="$t('configurations.send_alerts_users_single')"
                    />
                  </div>
                  <el-form-item prop="EmailAvisoSecundario">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      aria-labelledby="group-email-aviso-secundario-label"
                      v-model="form.EmailAvisoSecundario"
                      :maxlength='maxLengthCorreos'
                    />
                  </el-form-item>
                </div>
              </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="(hasModuleCustomSMTPCliente || (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')) && form.tipo && form.tipo !== 3"
            ref="baseCollapsibleCustomMailSmtp" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.custom_mail_smtp')}}</h2>
                <base-tooltip-icon 
                  size="sm" 
                  :content="$t('tooltip.groups.contentTooltipSMTP')" 
                  class="ml-2"/>
              </div>
            </template>
            <template slot="content">

            <div class="mb-4">
              <label for="smtp-main-switch" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('smtp.main')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('smtp.default_group')}} / {{$t('smtp.custom')}}</span>
              </label>
              <el-switch 
                id="smtp-main-switch"
                :aria-label="$t('smtp.main')"
                disabled
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.smtpMain" 
                :active-text="$t('smtp.custom')"
                :inactive-text="$t('smtp.default_group')"
                inactive-color="var(--primary-800)"/>
            </div>

            <div v-if="form.smtpMain">
              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smtpServer">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.smtpServer"
                        maxlength='200'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smtpFrom">
                      <el-input
                        disabled
                        class="w-full"
                        v-model="form.smtpFrom"
                        maxlength='100'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smtpPort">
                      <el-input
                        disabled
                        class="w-full"
                        v-model.number="form.smtpPort"
                        maxlength='10'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="mb-4">
                <label for="smtp-ssl-switch" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.ssl')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                </label>
                <el-switch 
                  id="smtp-ssl-switch"
                  :aria-label="$t('smtp.ssl')"
                  disabled
                  class="switch-text break-normal both-switch mt-2" 
                  v-model="form.smptSSL" 
                  :active-text="$t('companies.active')"/>
              </div>

              <div class="mb-4">
                <label for="smtp-oauth2-switch" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.oauth2')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                </label>
                <el-switch 
                  id="smtp-oauth2-switch"
                  :aria-label="$t('smtp.oauth2')"
                  disabled
                  class="switch-text break-normal both-switch mt-2" 
                  v-model="form.smptOAuth2" 
                  :active-text="$t('companies.active')"/>
              </div>

              <div class="lg:mb-2" v-if="form.smptOAuth2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smptClientId">
                      <el-input
                        disabled
                        class="w-full"
                        v-model="form.smptClientId"
                        maxlength='100'
                      />
                    </el-form-item>
                  </label>                  
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.smptOAuth2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smptTenantId">
                      <el-input
                        disabled
                        class="w-full"
                        v-model="form.smptTenantId"
                        maxlength='100'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smtpUser">
                      <el-input
                        disabled
                        class="w-full"
                        v-model="form.smtpUser"
                        maxlength='100'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <el-form-item prop="smtpPass">
                      <el-input
                        disabled
                        class="w-full"
                        v-model="form.smtpPass"
                        autocomplete="new-password"
                        maxlength='100'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>

            </template>
          </base-collapsible-form>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="$t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="trash"
            @click="deleteGroup()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="restore"
            @click="restoreGroup()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
        title="Borrar grupo"
        :visible.sync="showModal"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-group')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessagedeleteGroup }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-group">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </BaseElDialog>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getClients } from '@/services/clients/getClients'
import { getGroup } from '@/services/configurations/groups/getGroup'
import { deleteTrashGroup } from '@/services/trash/deleteTrashGroup'
import { restoreTrashGroup } from '@/services/trash/restoreTrashGroup'
import { i18n } from '@/i18n'
import { TIPOS_GRUPO } from '@/config/tipos-grupo'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-grupo',
  components: {
    DetailLayoutFullWidth,
    BaseElDialog,
    AccessibleElSelect
  },
  data: function () {
    return {
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'DETALLE DE GRUPO BORRADO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'trash/groups'
      },
      maxLengthCorreos: 500,
      form: this.getDefaultForm(),
      tiposGrupo: TIPOS_GRUPO,
      clientes: [],
      tooltipverTodoGroups: this.$i18n.t('tooltip.groups.ver_todo_groups'),
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.groups.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.groups.ver_todo_companies'),
      tooltipTipoGrupo: this.$i18n.t('tooltip.html.groups.tipo_grupo'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      showModal: false,
      processMessagedeleteGroup: '¿Estás seguro que deseas borrar permanente el grupo?',
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    tiposGrupoFiltered () {
      if (this.isCreate) return this.tiposGrupo.filter(x => x.create)
      else return this.tiposGrupo
    },
    formatCodigoPaisSMSAvisoDescargada () {
      if (this.form?.CodigoPaisSMSAvisoDescargada === '0034') return '+34'
      return 'Desconocido'
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS']
    },
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasModuleCustomSMTPCliente']
    },
    hasModuleCustomSMTPZerocoma () {
      return this.$store.getters['auth/hasModuleCustomSMTPZerocoma']
    },
    hasModulePermisosGruposTraspasoNEOs () {
      return this.$store.getters['auth/hasModulePermisosGruposTraspasoNEOs']
    },
    hasModuleFlujoEstadosAvisos () {
      return this.$store.getters['auth/hasModuleFlujoEstadosAvisos']
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        name: cliente.Nombre,
        value: cliente.IdEmpresa
      }))
    },
    tiposGrupoForAccessibleSelect () {
      return this.tiposGrupo.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id
      }))
    },
  },
  watch: {
  },
  created: async function () {
    const breadcrumbs = []
    
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
    }

    await this.downloadData(this.id)
    if (this.form.tipo === 3) {
      this.$refs.baseCollapsibleAlerts.openAndDisable()
    }
    breadcrumbs.push({ path: 'trash/groups', name: this.$i18n.t('app.trash') })
    breadcrumbs.push({ path: 'trash/groups', name: this.$i18n.t('trash.groups') })
    breadcrumbs.push({ path: '', name: this.form.name })
    this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteGroup () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        payload.idGrupos.push(this.id)
        const response = await deleteTrashGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreGroup: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idGrupos: []
        }
        payload.idGrupos.push(this.id)
        const response = await restoreTrashGroup(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        tipo: null,

        company: '',
        active: false,
        clienteId: null,
        verTodoGroups: false,
        verTodoAsignarGrupos: true,
        verTodoStatuses: false,
        verTodoCompanies: false,
        Descripcion: '',

        EmailAvisoNueva: '',
        EmailAvisoDescargada: '',
        CodigoPaisSMSAvisoDescargada: '0034',
        SMSAvisoDescargada: '',
        EmailAvisoTramitada: '',
        DiasAviso: 0,
        DiasAvisoFinTramite: 0,
        AgruparEmailsAvisos: true,
        EmailAvisoUltimaLlamada: '',
        EmailAvisoTramitacionUrgente: '',
        EmailAvisoErrores: '',
        EnviarAvisos: true,
        EnviarAvisosUsuarios: false,
        EnviarAvisoUsuariosEmailAvisoNueva: false,
        EnviarAvisoUsuariosEmailAvisoDescargada: false,
        EnviarAvisoUsuariosEmailAvisoTramitada: false,
        EnviarAvisoUsuariosEmailAvisoDiasAviso: false,
        EnviarAvisoUsuariosEmailAvisoTramitacionUrgente: false,
        EnviarAvisoUsuariosEmailAvisoErrores: false,
        EnviarAvisoUsuariosEmailAvisoVinculaciones: false,
        EnviarAvisoUsuariosEmailAvisoPrincipal: false,
        EnviarAvisoUsuariosEmailAvisoSecundario: false,
        EmailAvisoVinculaciones: '',
        EmailAvisoPrincipal: '',
        EmailAvisoSecundario: '',

        smtpMain: false,
        smtpServer: null,
        smtpFrom: null,
        smtpPort: null,
        smptSSL: true,
        smptOAuth2: null,
        smptClientId: null,
        smptTenantId: null,
        smtpUser: null,
        smtpPass: null,
      }
    },
    watchFormHandler: function ({
      certificate,
      send_alerts,
      automatic_download
    }) {},
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    goBack: function () {
      this.$router.push({ name: 'trash/groups' })
    },
    downloadData: async function (id) {
      let group = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idGrupo: id,
          borrado: true,
        }
        group = await getGroup(params)
        this.setGroup(group.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return group
    },
    setGroup: function (group) {
      this.form.id = group.IdGrupo
      this.form.name = group.Nombre
      this.form.email = group.Emails
      this.form.tipo = group.idTipoGrupo
      this.form.clienteId = group.idEmpresa
      this.form.verTodoGroups = group.VerTodoGrupos
      this.form.verTodoAsignarGrupos = group.VerTodoAsignarGrupos
      this.form.verTodoStatuses = group.VerTodoEstados
      this.form.verTodoCompanies = group.VerTodoEmpresas
      this.form.Descripcion = group.Descripcion

      this.form.EmailAvisoNueva = group.EmailAvisoNueva ? group.EmailAvisoNueva : null
      this.form.EmailAvisoDescargada = group.EmailAvisoDescargada ? group.EmailAvisoDescargada : null
      this.form.SMSAvisoDescargada = group.NumeroSMSDescargadas ? group.NumeroSMSDescargadas.substring(4) : null
      this.form.EmailAvisoTramitada = group.EmailAvisoTramitada ? group.EmailAvisoTramitada : null
      this.form.EmailAvisoUltimaLlamada = group.EmailDiasAviso ? group.EmailDiasAviso : null
      this.form.EmailAvisoTramitacionUrgente = group.EmailAvisoTramitacionUrgente ? group.EmailAvisoTramitacionUrgente : null
      this.form.EmailAvisoErrores = group.EmailAvisoErrores ? group.EmailAvisoErrores : null
      this.form.AgruparEmailsAvisos = group.AgruparEmailsAvisos ? group.AgruparEmailsAvisos : false
      this.form.EnviarAvisos = group.EnviarAvisos
      this.form.EnviarAvisosUsuarios = group.EnviarAvisosUsuarios
      this.form.EnviarAvisoUsuariosEmailAvisoNueva = group.EnviarAvisoUsuariosEmailAvisoNueva
      this.form.EnviarAvisoUsuariosEmailAvisoDescargada = group.EnviarAvisoUsuariosEmailAvisoDescargada
      this.form.EnviarAvisoUsuariosEmailAvisoTramitada = group.EnviarAvisoUsuariosEmailAvisoTramitada
      this.form.EnviarAvisoUsuariosEmailAvisoDiasAviso = group.EnviarAvisoUsuariosEmailAvisoDiasAviso
      this.form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente = group.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente
      this.form.EnviarAvisoUsuariosEmailAvisoErrores = group.EnviarAvisoUsuariosEmailAvisoErrores
      this.form.EnviarAvisoUsuariosEmailAvisoVinculaciones = group.EnviarAvisoUsuariosEmailAvisoVinculaciones
      this.form.EnviarAvisoUsuariosEmailAvisoPrincipal = group.EnviarAvisoUsuariosEmailAvisoPrincipal
      this.form.EnviarAvisoUsuariosEmailAvisoSecundario = group.EnviarAvisoUsuariosEmailAvisoSecundario
      this.form.EmailAvisoVinculaciones = group.EmailAvisoVinculaciones ? group.EmailAvisoVinculaciones : null
      this.form.EmailAvisoPrincipal = group.EmailAvisoPrincipal ? group.EmailAvisoPrincipal : null
      this.form.EmailAvisoSecundario = group.EmailAvisoSecundario ? group.EmailAvisoSecundario : null
      
      this.form.DiasAviso = group.DiasAviso !== null || group.DiasAviso !== undefined ? group.DiasAviso : null
      this.form.DiasAvisoFinTramite = group.DiasFinTramite !== null || group.DiasFinTramite !== undefined ? group.DiasFinTramite : null
      this.setDataSmtp(group.ConfigSMTP)
    },
    setDataSmtp: function (data) {
      if (data) {
        this.form.smtpMain = true
        this.form.smtpServer = data.Servidor
        this.form.smtpFrom = data.UsrDefecto
        this.form.smtpPort = data.Puerto
        this.form.smptSSL = data.SSL
        this.form.smptClientId = data.ClientId
        this.form.smptTenantId = data.TenantId
        this.form.smtpUser = data.Usuario
        this.form.smtpPass = '**********'
        this.form.smptOAuth2 = (data.ClientId != null && data.TenantId != null)
      } else {
        this.form.smtpMain = false
        this.visibleEditPass = false
        this.disableEditPass = false
      }
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.switch-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.switch-row > .el-switch {
  flex-shrink: 0;
  max-width: 100%;
  margin-left: auto;
}
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
